import { render, staticRenderFns } from "./campuspr.vue?vue&type=template&id=99d4f712&"
import script from "./campuspr.vue?vue&type=script&lang=js&"
export * from "./campuspr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports